import { api } from './client'
import type {
  WishlistEntry,
  WishlistResponse,
  PlayingEntryWithGame,
  PlayedEntryWithGame,
} from '@/types'

// Wishlist
export function fetchWishlist(groupId: string): Promise<WishlistResponse> {
  return api.get<WishlistResponse>(`/groups/${groupId}/wishlist`)
}

export function addToWishlist(groupId: string, gameId: string): Promise<WishlistEntry> {
  return api.post<WishlistEntry>(`/groups/${groupId}/wishlist`, { gameId })
}

export function removeFromWishlist(groupId: string, gameId: string): Promise<void> {
  return api.delete<void>(`/groups/${groupId}/wishlist/${gameId}`)
}

export function voteOnGame(groupId: string, gameId: string, vote: 1 | -1 | 0): Promise<void> {
  return api.put<void>(`/groups/${groupId}/wishlist/${gameId}/vote`, { vote })
}

// On Deck — a flag on a wishlisted game marking it as "next up"
export function markOnDeck(groupId: string, gameId: string): Promise<void> {
  return api.put<void>(`/groups/${groupId}/wishlist/${gameId}/ondeck`)
}

export function unmarkOnDeck(groupId: string, gameId: string): Promise<void> {
  return api.delete<void>(`/groups/${groupId}/wishlist/${gameId}/ondeck`)
}

export function reorderOnDeck(groupId: string, gameIds: string[]): Promise<void> {
  return api.put<void>(`/groups/${groupId}/wishlist/ondeck/order`, { gameIds })
}

// Playing
export function fetchPlaying(groupId: string): Promise<PlayingEntryWithGame[]> {
  return api.get<PlayingEntryWithGame[]>(`/groups/${groupId}/playing`)
}

export function promoteToPlaying(groupId: string, gameId: string): Promise<PlayingEntryWithGame> {
  return api.post<PlayingEntryWithGame>(`/groups/${groupId}/playing`, { gameId })
}

export function updatePlayingEntry(
  groupId: string,
  gameId: string,
  note: string,
): Promise<PlayingEntryWithGame> {
  return api.patch<PlayingEntryWithGame>(`/groups/${groupId}/playing/${gameId}`, { note })
}

export function removeFromPlaying(groupId: string, gameId: string): Promise<void> {
  return api.delete<void>(`/groups/${groupId}/playing/${gameId}`)
}

// Played
export function fetchPlayed(groupId: string): Promise<PlayedEntryWithGame[]> {
  return api.get<PlayedEntryWithGame[]>(`/groups/${groupId}/played`)
}

export function promoteToPlayed(groupId: string, gameId: string): Promise<PlayedEntryWithGame> {
  return api.post<PlayedEntryWithGame>(`/groups/${groupId}/played`, { gameId })
}

export function rateGame(groupId: string, gameId: string, rating: number): Promise<void> {
  return api.put<void>(`/groups/${groupId}/played/${gameId}/rating`, { rating })
}

export function removeFromPlayed(groupId: string, gameId: string): Promise<void> {
  return api.delete<void>(`/groups/${groupId}/played/${gameId}`)
}
